import { DateValue } from 'react-aria';
import { Controller, useFormContext } from 'react-hook-form';
import DatePicker from 'src/components/date-picker/DatePicker';
import TextField from 'src/components/TextField';

import { ServiceIndependentFormData } from '../RelatedService.schema';
import { formatPhoneNumber } from '../RelatedService.utils';

type ServiceIndependentFormProps = {
  year: string;
  isDateDisabled?: (d: DateValue) => boolean;
};

export const ServiceIndependentForm = ({ year, isDateDisabled }: ServiceIndependentFormProps) => {
  const { control } = useFormContext<ServiceIndependentFormData>();

  const handlePhoneChange = (field: any, value: string) => {
    const formatted = formatPhoneNumber(value);
    field.onChange(formatted);
  };

  return (
    <div className="mt-4 flex flex-col gap-6 border-t border-neutral-800 bg-secondary-900 pt-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Controller
          name="startDate"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <div className="flex flex-col gap-1">
              <p className="text-neutral-400 typography-body-sm">{`${year} Start Date`}</p>
              <DatePicker
                error={error?.message}
                value={field.value}
                onChange={field.onChange}
                isDateDisabled={isDateDisabled}
              />
            </div>
          )}
        />

        <Controller
          name="providerName"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <div className="flex flex-col gap-1">
              <p className="text-neutral-400 typography-body-sm">Provider Name</p>
              <TextField error={error?.message} {...field} />
            </div>
          )}
        />

        <Controller
          name="providerPhoneNumber"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <div className="flex flex-col gap-1">
              <p className="text-neutral-400 typography-body-sm">Provider Phone Number</p>
              <TextField
                error={error?.message}
                {...field}
                onChange={(e) => handlePhoneChange(field, e.target.value)}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
};
